import React from "react";
import { makeStyles } from "@material-ui/core";
import { green, red } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { ReactComponent as UserCheck } from 'bootstrap-icons/icons/person-fill-check.svg';
import { ReactComponent as UserExclamation } from 'bootstrap-icons/icons/person-fill-exclamation.svg';

const useStyles = makeStyles(theme => ({
    on: {
        color: green[600],
        width: "20px",
        height: "20px"
    },
    off: {
        color: red[600],
        width: "20px",
        height: "20px"
    }
}));

const UserStatusIcon = ({ user }) => {
    const classes = useStyles();
    
    return user.online ?
        <UserCheck className={classes.on} />
        : <UserExclamation className={classes.off} />
}

export default UserStatusIcon;